/**
 * Unified Bundle Entry Point - Card-Only Variant
 *
 * Usage:
 * <script src="https://widgets.talkn.io/card"></script>
 * <div class="talkn-card" data-ch="/example.com/"></div>
 */

import '@api-client/index';
import { TalknWidgets } from '../../index';
import '../../ranking/horizonCard/src/index';
import { autoInit } from '../autoInit';

autoInit(TalknWidgets);

export default TalknWidgets;
